import React, { useEffect, useState } from 'react';
import { Form, Button, Spinner } from 'react-bootstrap';
import axios from 'axios';
import Input, { InputF } from '../../components/Input';
import Env from '../../hooks/Env';
import './index.css';

export const RADIUS_API = `${Env().API_URL}/radius`;
// Date limite : 16 octobre 2026 à 15h (heure de Dakar = UTC)
export const DATE_LIMITE = new Date('2026-10-16T15:00:00Z');
const maxFileSize = 2 * 1024 * 1024; // 2 Mo

export const PIECES = [
    { name: 'lettre_motivation', label: 'Lettre de motivation ou demande adressée au chef du Département STAAN', required: true },
    { name: 'cv', label: 'Curriculum vitæ (CV) détaillé et actualisé', required: true },
    { name: 'justificatif_recherche', label: "Justificatif d'engagement dans une thématique de recherche liée à l'agroécologie", required: true },
    { name: 'canevas', label: 'Canevas de recherche (2 pages maximum)', required: true },
    { name: 'lettre_encadrant1', label: "Lettre d'engagement d'un encadrant (STAAN / Polytech Diamniadio / UAM)", required: true },
    { name: 'lettre_encadrant2', label: "Deuxième lettre d'engagement d'un encadrant (facultatif)", required: false },
];

function Radius() {
    useEffect(() => { document.title = 'Appel à candidature RADiUS'; }, []);
    const [dataForm, setDataForm] = useState({});
    const [selectedFiles, setSelectedFiles] = useState({});
    const [fileErrors, setFileErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [erreur, setErreur] = useState('');
    const [succes, setSucces] = useState(null);
    const cloture = new Date() > DATE_LIMITE;

    function handleChange(e) {
        setDataForm({ ...dataForm, [e.target.name]: e.target.value });
    }

    const handleFileChange = (event, key) => {
        const file = event.target.files[0];
        if (!file) {
            setSelectedFiles((prev) => ({ ...prev, [key]: undefined }));
            setFileErrors((prev) => ({ ...prev, [key]: '' }));
        } else if (file.type !== 'application/pdf') {
            setSelectedFiles((prev) => ({ ...prev, [key]: undefined }));
            setFileErrors((prev) => ({ ...prev, [key]: 'Le fichier doit être au format PDF.' }));
        } else if (file.size > maxFileSize) {
            setSelectedFiles((prev) => ({ ...prev, [key]: undefined }));
            setFileErrors((prev) => ({ ...prev, [key]: 'Taille du fichier > 2 Mo, veuillez le réduire.' }));
        } else {
            setSelectedFiles((prev) => ({ ...prev, [key]: file }));
            setFileErrors((prev) => ({ ...prev, [key]: '' }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErreur('');
        if (!/^\d{9}$/.test(dataForm.telephone || '')) {
            setErreur('Le numéro de téléphone doit contenir 9 chiffres (ex : 771234567).');
            return;
        }
        const manquantes = PIECES.filter((p) => p.required && !selectedFiles[p.name]);
        if (manquantes.length > 0) {
            setErreur('Pièce(s) manquante(s) ou invalide(s) : ' + manquantes.map((p) => p.label).join(' ; '));
            return;
        }
        const formData = new FormData();
        for (const key in dataForm) {
            formData.append(key, dataForm[key]);
        }
        PIECES.forEach((p) => {
            if (selectedFiles[p.name]) formData.append(p.name, selectedFiles[p.name]);
        });
        setSubmitted(true);
        try {
            const response = await axios.post(`${RADIUS_API}/`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (response.data?.detail) {
                setErreur(response.data.detail);
            } else {
                setSucces(response.data?.data || dataForm);
                window.scrollTo(0, 0);
            }
        } catch (error) {
            console.error('Error', error);
            setErreur(error?.response?.data?.detail
                || "Une erreur est survenue lors de l'envoi du dossier. Veuillez réessayer.");
        } finally {
            setSubmitted(false);
        }
    };

    return (
        <div className='container mb-4' id='radiusPage'>
            <h2 className='radius-section'>Date limite et dépôt des candidatures</h2>
            <ul>
                <li><strong>Date limite : 16 octobre 2026 à 15h</strong></li>
                <li><strong>Dépôt : via le formulaire ci-dessous</strong></li>
            </ul>
            {succes ? (
                <div className='alert alert-success'>
                    <h5>Votre candidature a bien été enregistrée.</h5>
                    <p className='m-0'>{succes.prenom} {succes.nom} ({succes.email}), merci pour votre dépôt.
                        Les candidat(e)s retenu(e)s seront contacté(e)s par le Département STAAN.</p>
                </div>
            ) : cloture ? (
                <div className='alert alert-warning'>
                    L'appel à candidature est clôturé depuis le 16 octobre 2026 à 15h.
                </div>
            ) : (
                <Form onSubmit={handleSubmit} className='radius-form'>
                    <Form.Group className='mb-2'>
                        <Form.Label className='fw-medium'>Civilité <span style={{ color: 'red' }}>*</span></Form.Label>
                        <div>
                            <Form.Check inline type='radio' label='Monsieur' value='Monsieur' name='civilite' required
                                checked={dataForm.civilite === 'Monsieur'} onChange={handleChange} />
                            <Form.Check inline type='radio' label='Madame' value='Madame' name='civilite' required
                                checked={dataForm.civilite === 'Madame'} onChange={handleChange} />
                        </div>
                    </Form.Group>
                    <div className='row'>
                        <Input className='col-md-6 col-sm-12 mb-2' type='text' label='Prénom' name='prenom' value={dataForm.prenom || ''} onChange={handleChange} />
                        <Input className='col-md-6 col-sm-12 mb-2' type='text' label='Nom' name='nom' value={dataForm.nom || ''} onChange={handleChange} />
                    </div>
                    <div className='row'>
                        <Input className='col-md-6 col-sm-12 mb-2' type='email' label='E-mail' name='email' value={dataForm.email || ''} onChange={handleChange} />
                        <Input className='col-md-6 col-sm-12 mb-2' type='tel' label='Téléphone' name='telephone' placeholder='771234567' value={dataForm.telephone || ''} onChange={handleChange} />
                    </div>
                    <div className='row'>
                        <Input className='col-md-6 col-sm-12 mb-2' type='text' label='Numéro de carte étudiant' name='numero_carte' value={dataForm.numero_carte || ''} onChange={handleChange} />
                        <Input className='col-md-6 col-sm-12 mb-2' type='text' label="Nom de l'encadrant principal" name='encadrant' value={dataForm.encadrant || ''} onChange={handleChange} />
                    </div>
                    <Input className='mb-2' type='text' label='Intitulé du sujet de recherche' name='sujet' value={dataForm.sujet || ''} onChange={handleChange} />
                    <Input className='mb-3' type='text' label="Structure de recherche d'accueil" name='structure_recherche' value={dataForm.structure_recherche || ''} onChange={handleChange} />

                    <p className='fw-bold mb-1'>Pièces à fournir (PDF, 2 Mo maximum par fichier)</p>
                    {PIECES.map((p) => (
                        <div key={p.name} className='mb-2'>
                            <InputF className='rounded-left' type='file' accept='.pdf' label={p.label} name={p.name}
                                required={p.required} onChange={(e) => handleFileChange(e, p.name)} />
                            {fileErrors[p.name] ? <span style={{ color: 'red' }}>{fileErrors[p.name]}</span> : null}
                        </div>
                    ))}

                    {erreur ? <div className='alert alert-danger mt-3' role='alert'>{erreur}</div> : null}
                    <Button variant='primary' type='submit' size='md' className='p-2 mt-2 float-end' disabled={submitted}>
                        Soumettre ma candidature {submitted ? <Spinner animation='grow' size='sm' role='status' /> : null}
                    </Button>
                    <div className='clearfix' />
                </Form>
            )}
        </div>
    );
}

export default Radius;
